export class GlovoMediaError extends Error {
    constructor(message, error, fileInformation) {
        super(`[glovo-multimedia] error: ${message}`);
        this.fileInformation = fileInformation || 'UNDEFINED_FILE_INFORMATION';
        this.error = error || 'UNDEFINED_ERROR';
        if (error) {
            this.stack = `${this.stack}\nCaused by: ${error.stack}`;
        }
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}
export class GlovoInvalidImageSourceError extends Error {
    constructor(message, errors, fileInformation) {
        super(`[glovo-multimedia] ${message}`);
        this.errorCodes = errors;
        this.fileInformation = fileInformation || 'UNDEFINED_FILE_INFORMATION';
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}
//# sourceMappingURL=errors.js.map